import Translation from "./translation.service";

const translationModule = angular
  .module("app.services.translation", [])
  .service("Translation", Translation);

export default translationModule;



// WEBPACK FOOTER //
// ./src/services/translation/translation.module.js